import { BottomNav } from "@/components/BottomNav";
import { AlertBanner } from "@/components/AlertBanner";
import { SitePopup } from "@/components/SitePopup";

export const PageHeader = ({ title, subtitle, action }) => (
  <div className="flex items-end justify-between gap-3 px-4 pt-6 pb-2">
    <div>
      {subtitle && (
        <p className="text-xs font-bold uppercase tracking-widest text-secondary">{subtitle}</p>
      )}
      <h1 className="font-display text-3xl font-bold tracking-tight text-primary sm:text-4xl">
        {title}
      </h1>
    </div>
    {action}
  </div>
);

export const AppLayout = ({ children }) => (
  <div className="min-h-screen bg-background">
    <main className="mx-auto max-w-lg pb-24">
      <AlertBanner />
      {children}
    </main>
    <BottomNav />
    <SitePopup />
  </div>
);
